import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconChevronUp = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M31.136 15.707a3.9 3.9 0 0 0-1.299.557c-.407.272-27.354 27.204-27.624 27.608-1.072 1.606.551 3.634 2.377 2.969.357-.13.859-.623 13.89-13.648L32 19.681l13.52 13.512c13.031 13.025 13.533 13.518 13.89 13.648.987.36 2.065-.07 2.522-1.003.148-.302.178-.448.177-.846-.003-.979 1.273.378-14.031-14.92-10.617-10.61-13.764-13.721-14.062-13.897a5 5 0 0 0-.8-.368c-.53-.18-1.531-.228-2.08-.1" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconChevronUp.displayName = 'IconChevronUp';